import React from 'react'
import PropTypes from 'prop-types'
import Button from '../../ui/Button'
import InfoCircleIcon from '../../ui/icons/InfoCircleIcon'

const FOOTER_CLASS = 'tw:flex! tw:items-center tw:justify-between tw:gap-2 tw:px-6 tw:py-4 '
  + 'tw:border-t tw:border-solid tw:border-gray-300'
const WARNING_CLASS = 'tw:flex tw:items-center tw:gap-1 tw:rounded! tw:bg-orange-100 '
  + 'tw:px-1.5 tw:py-0.5 tw:text-sm tw:text-orange-700'
const ACTIONS_CLASS = 'tw:flex tw:items-center tw:gap-2 tw:ml-auto'

const WARNING_TEXT = 'Les modifications ne sont pas enregistrées'

const IssueDrawerFooter = ({ isDirty, saving, onCancel, onSave }) => (
  <footer className={FOOTER_CLASS}>
    {isDirty ? (
      <span className={WARNING_CLASS}>
        <InfoCircleIcon className="tw:w-3.5 tw:h-3.5" />
        <span>{WARNING_TEXT}</span>
      </span>
    ) : null}
    <span className={ACTIONS_CLASS}>
      <Button disabled={saving} variant="neutral" onClick={onCancel}>Annuler</Button>
      <Button disabled={saving} variant="primary" onClick={onSave}>
        {saving ? 'Enregistrement...' : 'Sauvegarder'}
      </Button>
    </span>
  </footer>
)

IssueDrawerFooter.propTypes = {
  isDirty: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired
}

export default IssueDrawerFooter
